export default __webpack_public_path__ + "static/media/cp_geo_un.52e795d9.svg";